export default __webpack_public_path__ + "static/media/uploadIcon.da937d18.svg";